/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { styled, SxProps, Theme } from "@mui/material";

import HelperMessage, { HelperCollapse } from "../../../../components/HelperMessage";
import Typography from "../../../../components/Typography";
import TestIds from "../../../../testIds";
import { generateImageUrl } from "../../../../util/helpers";
import { CartItem } from "../../../cart/storage/cart.types";
import { Product } from "../../storage";

import { ProductCardParent } from "./ProductCardParent";

export const Container = styled("div")({
  display: "flex",
  flexDirection: "column",
  padding: "16px",
  gap: "16px",
});

interface AlternativeProductProps {
  item: Product | CartItem;
  title: string;
  contactInfo: {
    name?: string | null;
    email?: string | null;
    phone?: string | null;
  };
  show: boolean;
  sx?: SxProps<Theme>;
}

export const AlternativeProduct = ({
  item,
  title,
  contactInfo,
  show,
  sx,
}: AlternativeProductProps) => {
  return (
    <HelperCollapse in={show}>
      <Container sx={sx}>
        <Typography variant="body1" fontWeight={"bold"} color="primary700">
          {title}
        </Typography>
        <ProductCardParent
          isPastProduct={false}
          isAlternativeProduct={true}
          enableQuote
          item={{
            ...item,
            imageUrl: generateImageUrl(item.itemNumber),
            sizeDescription: item.size,
            colourDescription: item.colour,
          }}
          testId={TestIds.feat.product.card.alternative}
        />
        <HelperMessage
          title="Not what your looking for?"
          body="Contact your Farmlands representative to learn about other available products."
          show={true}
          name={contactInfo.name}
          phone={contactInfo.phone}
          email={contactInfo.email}
          sx={{ m: 0 }}
        />
      </Container>
    </HelperCollapse>
  );
};
